var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00983F",
    d: "M14.625,62.25 C13.90625,62.25 13.1875,61.9625 12.6125,61.3875 L6.8625,55.6375 C5.7125,54.4875 5.7125,52.7625 6.8625,51.6125 C8.0125,50.4625 9.88125,50.4625 10.8875,51.6125 L14.625,55.35 L24.1125,45.8625 C25.2625,44.7125 26.9875,44.7125 28.1375,45.8625 C29.2875,47.0125 29.2875,48.7375 28.1375,49.8875 L16.6375,61.3875 C16.0625,61.9625 15.34375,62.25 14.625,62.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00983F",
    d: "M57,9 C61.9705627,9 66,13.0294373 66,18 L65.9999871,45.029 L66.0748134,45 L66.0748134,58.7573593 C66.0748134,60.4142136 64.7316677,61.7573593 63.0748134,61.7573593 C62.279164,61.7573593 61.5161022,61.4412888 60.9534931,60.8786797 L54.0749871,54 L38.9508313,54.0005789 C38.1792351,42.2732574 28.4225602,33 16.5,33 C12.7077197,33 9.13456705,33.9381972 5.99998714,35.5951466 L6,18 C6,13.0294373 10.0294373,9 15,9 L57,9 Z M45,21 L18,21 C16.3431458,21 15,22.3431458 15,24 C15,25.6568542 16.3431458,27 18,27 L18,27 L45,27 C46.6568542,27 48,25.6568542 48,24 C48,22.3431458 46.6568542,21 45,21 L45,21 Z"
  })))));
}
export default SvgSuccess;